/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetTabsCount200ResponseData
 */
export interface GetTabsCount200ResponseData {
  /**
   * Все регистры
   * @type {number}
   * @memberof GetTabsCount200ResponseData
   */
  ALL: number
  /**
   * Срок действия больше года
   * @type {number}
   * @memberof GetTabsCount200ResponseData
   */
  VALID: number
  /**
   * Срок действия меньше года либо истёк не более 6 месяцев назад
   * @type {number}
   * @memberof GetTabsCount200ResponseData
   */
  EXPIRES: number
  /**
   * Регистр не подлежит восстановлению
   * @type {number}
   * @memberof GetTabsCount200ResponseData
   */
  EXPIRED: number
}

/**
 * Check if a given object implements the GetTabsCount200ResponseData interface.
 */
export function instanceOfGetTabsCount200ResponseData(
  value: object
): value is GetTabsCount200ResponseData {
  if (!('ALL' in value) || value['ALL'] === undefined) return false
  if (!('VALID' in value) || value['VALID'] === undefined) return false
  if (!('EXPIRES' in value) || value['EXPIRES'] === undefined) return false
  if (!('EXPIRED' in value) || value['EXPIRED'] === undefined) return false
  return true
}

export function GetTabsCount200ResponseDataFromJSON(
  json: any
): GetTabsCount200ResponseData {
  return GetTabsCount200ResponseDataFromJSONTyped(json, false)
}

export function GetTabsCount200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetTabsCount200ResponseData {
  if (json == null) {
    return json
  }
  return {
    ALL: json['ALL'],
    VALID: json['VALID'],
    EXPIRES: json['EXPIRES'],
    EXPIRED: json['EXPIRED'],
  }
}

export function GetTabsCount200ResponseDataToJSON(
  value?: GetTabsCount200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    ALL: value['ALL'],
    VALID: value['VALID'],
    EXPIRES: value['EXPIRES'],
    EXPIRED: value['EXPIRED'],
  }
}
